import React, { FC } from "react";

import { ChipProps } from "@mui/material";

import * as Styled from "./styles";

const CloseIcon = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>((props, ref) => (
  <span
    {...props}
    ref={ref}
    style={{
      width: 24,
      height: 24,
      borderRadius: "50%",
      background: "rgba(156,211,253,0.15)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      ...props.style,
    }}
  >
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2.5" strokeLinecap="round">
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </svg>
  </span>
));
CloseIcon.displayName = "CloseIcon";

type TChip = ChipProps;

export const Chip: FC<TChip> = (props) => {
  return <Styled.Chip {...props} deleteIcon={<CloseIcon />} />;
};
